<template>
  <!-- <ManageCookiesPopup v-if="showCookiePopup" @close-cookie-popup-child="closeCookiePopup" @close-cookie-popup-child-and-close-cookie-banner="closeCookiePopup"/> -->
  <FocusTrap :active="isDrawerOpen">
    <div
      class="settings-drawer"
      :class="{ 'settings-drawer__open': isDrawerOpen }"
      @mouseover="isHovered = true"
      @mouseleave="isHovered = false"
    >
      <div class="settings-drawer__content">
        <div class="settings-drawer__content-inner">
          <QualityToggle :isSelectable="isDrawerOpen" />
          <!-- <LanguageDropdown :isSelectable="isDrawerOpen" /> -->
          <FilterDropdown
            :isSelectable="isDrawerOpen"
            @filersHovered="
              bool => {
                isHovered = bool;
              }
            "
          />
          <!-- <button class="cookieSettings" @click="openCookiePopup"><p>Cookie Consent Tool</p></button> -->
        </div>
      </div>
      <button
        class="settings-drawer__icon"
        @click="showHideMenu(!isDrawerOpen)"
        tabindex="0"
        :aria-label="
          isDrawerOpen
            ? $t('general.settings.close')
            : $t('general.settings.open')
        "
      >
        <transition-group name="quick-fade" mode="out-in">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-show="!isDrawerOpen"
            key="settings-icon"
          >
            <path
              d="M17.4121 9.64844C17.4121 9.70703 17.4121 9.76562 17.4121 9.82422C17.4186 9.88281 17.4219 9.94141 17.4219 10C17.4219 10.0586 17.4186 10.1172 17.4121 10.1758C17.4121 10.2344 17.4121 10.293 17.4121 10.3516L19.9414 11.9238L18.3887 15.6641L15.4883 15C15.332 15.1693 15.1693 15.332 15 15.4883L15.6641 18.3887L11.9238 19.9414L10.3516 17.4121C10.293 17.4121 10.2344 17.4154 10.1758 17.4219C10.1172 17.4219 10.0586 17.4219 10 17.4219C9.94141 17.4219 9.88281 17.4219 9.82422 17.4219C9.76562 17.4154 9.70703 17.4121 9.64844 17.4121L8.07617 19.9414L4.33594 18.3887L5 15.4883C4.83073 15.332 4.66797 15.1693 4.51172 15L1.61133 15.6641L0.0585938 11.9238L2.58789 10.3516C2.58789 10.293 2.58464 10.2344 2.57812 10.1758C2.57812 10.1172 2.57812 10.0586 2.57812 10C2.57812 9.94141 2.57812 9.88281 2.57812 9.82422C2.58464 9.76562 2.58789 9.70703 2.58789 9.64844L0.0585938 8.07617L1.61133 4.33594L4.51172 5C4.66797 4.83073 4.83073 4.66797 5 4.51172L4.33594 1.61133L8.07617 0.0585938L9.64844 2.58789C9.70703 2.58789 9.76562 2.58789 9.82422 2.58789C9.88281 2.58138 9.94141 2.57812 10 2.57812C10.0586 2.57812 10.1172 2.58138 10.1758 2.58789C10.2344 2.58789 10.293 2.58789 10.3516 2.58789L11.9238 0.0585938L15.6641 1.61133L15 4.51172C15.1693 4.66797 15.332 4.83073 15.4883 5L18.3887 4.33594L19.9414 8.07617L17.4121 9.64844ZM16.2695 10.918C16.2826 10.7617 16.2956 10.6087 16.3086 10.459C16.3216 10.3027 16.3281 10.1465 16.3281 9.99023C16.3281 9.84049 16.3216 9.6875 16.3086 9.53125C16.2956 9.375 16.2826 9.22201 16.2695 9.07227L18.5742 7.63672L17.7344 5.60547L15.0879 6.2207C14.8861 5.97331 14.6777 5.74544 14.4629 5.53711C14.2546 5.32878 14.0267 5.12044 13.7793 4.91211L14.3945 2.26562L12.3633 1.42578L10.918 3.73047C10.7682 3.71745 10.6152 3.70443 10.459 3.69141C10.3027 3.67839 10.1497 3.67188 10 3.67188C9.84375 3.67188 9.6875 3.67839 9.53125 3.69141C9.38151 3.70443 9.22852 3.71745 9.07227 3.73047L7.63672 1.42578L5.60547 2.26562L6.2207 4.91211C5.97331 5.11393 5.74544 5.32227 5.53711 5.53711C5.32878 5.74544 5.12044 5.97331 4.91211 6.2207L2.26562 5.60547L1.42578 7.63672L3.73047 9.08203C3.71745 9.23828 3.70443 9.39453 3.69141 9.55078C3.67839 9.70052 3.67188 9.85352 3.67188 10.0098C3.67188 10.1595 3.67839 10.3125 3.69141 10.4688C3.70443 10.625 3.71745 10.778 3.73047 10.9277L1.42578 12.3633L2.26562 14.3945L4.91211 13.7793C5.11393 14.0267 5.31901 14.2546 5.52734 14.4629C5.74219 14.6712 5.97331 14.8796 6.2207 15.0879L5.60547 17.7344L7.63672 18.5742L9.08203 16.2695C9.23177 16.2826 9.38477 16.2956 9.54102 16.3086C9.69727 16.3216 9.85026 16.3281 10 16.3281C10.1562 16.3281 10.3092 16.3216 10.459 16.3086C10.6152 16.2956 10.7715 16.2826 10.9277 16.2695L12.3633 18.5742L14.3945 17.7344L13.7793 15.0879C14.0267 14.8861 14.2546 14.681 14.4629 14.4727C14.6712 14.2578 14.8796 14.0267 15.0879 13.7793L17.7344 14.3945L18.5742 12.3633L16.2695 10.918ZM10 6.32812C10.5078 6.32812 10.9831 6.42578 11.4258 6.62109C11.875 6.8099 12.2656 7.07031 12.5977 7.40234C12.9297 7.73438 13.1901 8.125 13.3789 8.57422C13.5742 9.01693 13.6719 9.49219 13.6719 10C13.6719 10.5078 13.5742 10.9863 13.3789 11.4355C13.1901 11.8783 12.9297 12.2656 12.5977 12.5977C12.2656 12.9297 11.875 13.1934 11.4258 13.3887C10.9831 13.5775 10.5078 13.6719 10 13.6719C9.49219 13.6719 9.01367 13.5775 8.56445 13.3887C8.12174 13.1934 7.73438 12.9297 7.40234 12.5977C7.07031 12.2656 6.80664 11.8783 6.61133 11.4355C6.42253 10.9863 6.32812 10.5078 6.32812 10C6.32812 9.49219 6.42253 9.01693 6.61133 8.57422C6.80664 8.125 7.07031 7.73438 7.40234 7.40234C7.73438 7.07031 8.12174 6.8099 8.56445 6.62109C9.01367 6.42578 9.49219 6.32812 10 6.32812ZM10 12.5781C10.3581 12.5781 10.6934 12.513 11.0059 12.3828C11.3184 12.2461 11.5918 12.0605 11.8262 11.8262C12.0605 11.5918 12.2428 11.3184 12.373 11.0059C12.5098 10.6934 12.5781 10.3581 12.5781 10C12.5781 9.64193 12.5098 9.30664 12.373 8.99414C12.2428 8.68164 12.0605 8.4082 11.8262 8.17383C11.5918 7.93945 11.3184 7.75716 11.0059 7.62695C10.6934 7.49023 10.3581 7.42188 10 7.42188C9.64193 7.42188 9.30664 7.49023 8.99414 7.62695C8.68164 7.75716 8.4082 7.93945 8.17383 8.17383C7.93945 8.4082 7.75391 8.68164 7.61719 8.99414C7.48698 9.30664 7.42188 9.64193 7.42188 10C7.42188 10.3581 7.48698 10.6934 7.61719 11.0059C7.75391 11.3184 7.93945 11.5918 8.17383 11.8262C8.4082 12.0605 8.68164 12.2461 8.99414 12.3828C9.30664 12.513 9.64193 12.5781 10 12.5781Z"
              fill="#4A4A4A"
            />
          </svg>
          <img
            src="@/assets/close-x.svg"
            v-show="isDrawerOpen"
            style="max-width: 16px;"
            key="settings-close-icon"
            alt=""
          />
        </transition-group>
      </button>
      <transition name="quick-fade">
        <FilterOptions
          v-if="!$store.state.loaderIsShowing && $store.state.isFilterOpen"
        />
      </transition>
    </div>
    <!-- <ManageCookiesPopup v-if="showCookiePopup" @close-cookie-popup-child="closeCookiePopup" @close-cookie-popup-child-and-close-cookie-banner="closeCookiePopup"/> -->
  </FocusTrap>
  <!-- <ManageCookiesPopup @close-cookie-popup-child="closeCookiePopup" @close-cookie-popup-child-and-close-cookie-banner="closeCookiePopup"/> -->
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { FocusTrap } from "focus-trap-vue";
import QualityToggle from "@/components/QualityToggle.vue";
// import LanguageDropdown from "@/components/LanguageDropdown.vue";
import FilterDropdown from "@/components/FilterDropdown.vue";
import FilterOptions from "@/components/FilterOptions.vue";
// import ManageCookiesPopup from "./ManageCookiesPopup.vue";

let OPEN_TIMEOUT = null;

export default {
  components: {
    QualityToggle,
    // LanguageDropdown,
    FocusTrap,
    FilterDropdown,
    FilterOptions,
    // ManageCookiesPopup,
  },
  // data() {
  //   return {
  //     showCookiePopup: false,
  //   };
  // },
  setup() {
    let route = useRoute();
    let store = useStore();
    let isDrawerOpen = ref(false);
    let isHovered = ref(false);
    let showCookiePopup = ref(false);

    watch(
      () => isHovered.value,
      newVal => {
        if (!newVal && isDrawerOpen.value) {
          setAutoCloseTimeout();
        } else {
          clearAutoCloseTimeout();
        }
      }
    );
    watch(
      () => route.path,
      () => {
        isDrawerOpen.value = false;
        store.commit("updateFilterOpen", false);
      }
    );

    watch(
      () => store.state.isMenuOpen,
      () => {
        isDrawerOpen.value = false;
        store.commit("updateFilterOpen", false);
      }
    );

    let clearAutoCloseTimeout = () => {
      if (OPEN_TIMEOUT) {
        window.clearTimeout(OPEN_TIMEOUT);
        OPEN_TIMEOUT = null;
      }
    };

    let setAutoCloseTimeout = () => {
      clearAutoCloseTimeout();
      OPEN_TIMEOUT = window.setTimeout(() => {
        isDrawerOpen.value = false;
        store.commit("updateFilterOpen", false);
      }, 5000);
    };

    return { isDrawerOpen, isHovered, showCookiePopup, };
  },
  methods: {
    showHideMenu(bool) {
      this.$store.commit("updateFilterOpen", false);
      this.isDrawerOpen = bool;
    },
    closeCookiePopup() {
      this.showCookiePopup = false;
    },
    openCookiePopup() {
      this.showCookiePopup = true;
    },
  },
};
</script>

<style lang="scss" scoped>

.cookieSettings {
margin: 2px 24px 0px;
background: none;
color: inherit;
border: none;
padding: 0;
font: inherit;
cursor: pointer;
// font-weight: 600;
}

.cookieSettings p {
    @include text(bodyBold);
    color: $extraDarkGray;
    padding-bottom: 0px;
    margin-right: 16px;
    text-decoration: underline;
  }

.settings-drawer {
  position: absolute;
  display: flex;
  align-items: center;
  top: $absoluteOuterPadding;
  right: $absoluteOuterPadding;
  padding-left: 12px;
  height: 38px;
  z-index: 30;
  transform: translateX(-44px);
  pointer-events: none;
  touch-action: none;

  &__icon {
    position: relative;
    width: 39px;
    height: 38px;
    cursor: pointer;
    border: none;
    @include backgroundBlur(#fff, 0.975, 0.8, 15px);
    border-radius: 2px 2px 2px 2px;
    border-left: 1px solid transparent;
    transition: 0.15s all ease-in-out;
    pointer-events: all;
    touch-action: auto;

    &:hover {
      background: rgba(255, 255, 255, 1) !important;
    }

    svg {
      width: 20px;
      height: 20px;
    }
    > * {
      position: absolute;
      top: 50%;
      left: calc(50% - 1px);
      transform: translate(-50%, -50%);
    }
  }

  &__content {
    overflow: hidden;
    height: 100%;
  }
  &__content-inner {
    display: flex;
    margin-left: 12px;
    transform: translateX(100%);
    @include backgroundBlur(#fff, 0.975, 0.8, 15px);
    border-radius: 2px 0px 0px 2px;
    height: 100%;
    transition: transform 0.35s ease;
  }

  &__open {
    pointer-events: all;
    touch-action: auto;

    .settings-drawer__icon {
      border-left: 1px solid #d5d5d5;
      @include backgroundBlur(#fff, 0.975, 0.8, 15px);
      border-radius: 0px 2px 2px 0px;
    }
    .settings-drawer__content-inner {
      transform: translateX(0);
      @include backgroundBlur(#fff, 0.975, 0.8, 15px);
    }
  }

  @include breakpoint("mobile") {
    align-items: flex-end;
    flex-direction: column-reverse;
    height: initial;
    &__content {
      height: 140px;
    }
    &__content-inner {
      flex-direction: column;
      justify-content: space-between;
      transform: translateX(0) translateY(-100%);
      height: 100px;
      transition: transform 0.35s ease;
      padding: 12px;
    }

    &__open {
      .settings-drawer__icon {
        border-left: 1px solid transparent;
        border-radius: 0px 2px 2px 0px;
      }
      .settings-drawer__content-inner {
        transform: translateX(0) translateY(0);
        border-radius: 2px 0 2px 2px;
      }
    }
  }
}
</style>
